import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ModalTeamInfoPage } from './modal-team-info';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    ModalTeamInfoPage,
  ],
  imports: [
    IonicPageModule.forChild(ModalTeamInfoPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class ModalTeamInfoPageModule {}



// WEBPACK FOOTER //
// ./src/pages/modal-team-info/modal-team-info.module.ts